module.exports = __webpack_public_path__ + "static/media/26UNRWA15.6229c6a9.jpg";